export { LpCollectionStatisticsStoreService } from './lp-collection-statistics-store.service';
